export function validateSafePlanID(value?: string) {
  let error;
  if (value && !/^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i.test(value)) {
    error = 'Die ID ist nicht gültig.';
  }
  return error;
}
